import React, { useEffect, useRef } from 'react'

import clsx from 'clsx'
import { format, isSameDay, parseISO } from 'date-fns'
import { useHistory, useParams } from 'react-router-dom'

import Avatar from '@material-ui/core/Avatar'
import Badge from '@material-ui/core/Badge'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import { getAvatarImgProps, getSafeAvatarUrl } from '../../helpers/avatarFallback'

import { useStyles } from './style'

export const TicketListItemNotifications = ({ ticket, groupActionButtons }) => {
  const classes = useStyles()
  const history = useHistory()
  // const [, setLoading] = useState(false)
  const { ticketId } = useParams()
  const isMounted = useRef(true)
  // const { user } = useContext(AuthContext)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  // const handleAcepptTicket = async ticket => {
  //   setLoading(true)
  //   try {
  //     await api.put(`/tickets/${ticket.id}`, {
  //       status: 'open',
  //       userId: user?.id
  //     })
  //   } catch (err) {
  //     setLoading(false)
  //     toastError(err)
  //   }
  //   if (isMounted.current) {
  //     setLoading(false)
  //   }
  //   history.push(`/tickets/${ticket.uuid}`)
  // }

  const handleSelectTicket = ticket => {
    history.push(`/tickets/${ticket.uuid}`)
  }

  return (
    <React.Fragment key={ticket.id}>
      <ListItem
        // dense
        button
        // onClick={e => {
        //   if (
        //     ticket.status === 'pending' &&
        //     (groupActionButtons || !ticket.isGroup)
        //   )
        //     return
        //   handleSelectTicket(ticket)
        // }}
        onClick={() => handleSelectTicket(ticket)}
        selected={ticketId && +ticketId === ticket.id}
        className={clsx(classes.ticket, {
          [classes.pendingTicket]: ticket.status === 'pending'
        })}
      >
        <ListItemAvatar className={classes.listItemAvatar}>
          <Badge
            className={classes.newMessagesCount}
            badgeContent={ticket.unreadMessages}
            classes={{
              badge: classes.badgeStyle
            }}
            overlap="rectangular"
          >
            <Avatar
              src={getSafeAvatarUrl(ticket?.contact?.profilePicUrl)}
              imgProps={getAvatarImgProps()}
            />
          </Badge>
        </ListItemAvatar>
        <ListItemText
          // disableTypography
          className={classes.listItemText}
          primaryTypographyProps={{ component: 'span' }}
          secondaryTypographyProps={{ component: 'span' }}
          primary={
            <div className={classes.contactNameWrapper}>
              <div className={classes.contactName}>
                <span>{ticket.contact.name}</span>
              </div>
              {ticket.status === 'closed' && (
                <Badge
                  className={classes.closedBadge}
                  badgeContent={'closed'}
                  color="primary"
                  overlap="rectangular"
                />
              )}
            </div>
          }
          secondary={
            <div className={classes.contactNameWrapper}>
              {ticket.lastMessage && (
                <div className={classes.lastMessageTime}>
                  <span>
                    {isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
                      <>{format(parseISO(ticket.updatedAt), 'HH:mm')}</>
                    ) : (
                      <>{format(parseISO(ticket.updatedAt), 'dd/MM/yyyy')}</>
                    )}
                  </span>
                </div>
              )}
            </div>
          }
        />
      </ListItem>
    </React.Fragment>
  )
}
